import axios from "axios";
import klerData from "../apis/klerData";
import zohoData from "../apis/zohoData";
import {
  FETCH_BRANDS,
  FETCH_COLORS,
  FETCH_CATEGORIES,
  FETCH_DISPLAYS,
  FETCH_GROUPS,
  FETCH_LOCATION,
  FETCH_LOCATION_USERS,
  FETCH_MEDIAS,
  FETCH_MENU_ITEMS,
  FETCH_MENU_ITEMS_MEDIA,
  FETCH_SORT_OPTIONS,
  FETCH_STRAIN_TYPES,
  FETCH_SUBSCRIPTION,
  FETCH_TERPENE_PROFILES,
  FETCH_THEMES,
  FETCH_USER,
  FETCH_USER_LOCATIONS,
  FETCH_ZOHO_CUSTOMERS
} from "./types";

export const fetchUser = () => async dispatch => {
  const res = await axios.get("/api/current_user");
  dispatch({ type: FETCH_USER, payload: res.data });
};

export const handleToken = token => async dispatch => {
  const res = await axios.post("/api/stripe", token);
  dispatch({ type: FETCH_USER, payload: res.data });
};

export const fetchBrands = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Brand?$filter=Oid ne 1 and SubscriptionId eq '${SubscriptionId}'&$orderby=Name&$select=Oid,Name,ColorCode&$expand=ColorCode&$format=json`
    );

    dispatch({ type: FETCH_BRANDS, payload: response.data.d });
  };
};

export const fetchColors = () => {
  return async dispatch => {
    const response = await klerData.get(
      `/Color?$orderby=Name&$select=Oid,Name,ColorCode&$format=json`
    );

    dispatch({ type: FETCH_COLORS, payload: response.data.d });
  };
};

export const fetchCategories = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Category?$filter=Oid ne 1 and SubscriptionId eq '${SubscriptionId}'&$orderby=Name&$select=Oid,Name,ColorCode&$expand=ColorCode&$format=json`
    );

    dispatch({ type: FETCH_CATEGORIES, payload: response.data.d });
  };
};

export const fetchDisplays = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Display?$filter=SubscriptionId eq '${SubscriptionId}'&$orderby=Name&$select=Name,Oid,Id,Orientation&$format=json`
    );

    dispatch({ type: FETCH_DISPLAYS, payload: response.data.d });
  };
};

export const fetchGroups = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Group?$filter=SubscriptionId eq '${SubscriptionId}' and Oid ne 1&$orderby=Name&$select=Name,Oid,Type&$format=json`
    );

    dispatch({ type: FETCH_GROUPS, payload: response.data.d });
  };
};

export const fetchLocation = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Subscription?$filter=SubscriptionId eq '${SubscriptionId}'&$format=json`
    );
    dispatch({ type: FETCH_LOCATION, payload: response.data.d });
  };
};

export const fetchLocationUsers = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/UserAccess?$filter=SubscriptionId/SubscriptionId eq '${SubscriptionId}'&$orderby=Email&$select=Oid,Email,Admin,SubscriptionId&$expand=SubscriptionId&$format=json`
    );

    dispatch({ type: FETCH_LOCATION_USERS, payload: response.data.d });
  };
};

export const fetchMedias = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Media?$filter=SubscriptionId eq '${SubscriptionId}'&$orderby=Name&$select=Name,Oid,Url&$format=json`
    );

    dispatch({ type: FETCH_MEDIAS, payload: response.data.d });
  };
};

export const fetchMenuItems = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/MenuItems?$filter=SubscriptionId eq '${SubscriptionId}' and Oid ne 3 and GroupToShow ne null&$orderby=GroupToShow/Name&$select=Name,Oid,GroupToShow&$expand=GroupToShow&$format=json`
    );

    dispatch({ type: FETCH_MENU_ITEMS, payload: response.data.d });
  };
};

export const fetchMenuItemsMedia = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/MenuItems?$filter=SubscriptionId eq '${SubscriptionId}' and Oid ne 3 and MediaToShow ne null&$orderby=MediaToShow/Name&$select=Name,Oid,MediaToShow&$expand=MediaToShow&$format=json`
    );

    dispatch({ type: FETCH_MENU_ITEMS_MEDIA, payload: response.data.d });
  };
};

export const fetchSortOptions = () => {
  return async dispatch => {
    const response = await klerData.get(
      `/SortOption?$filter=Name ne 'Name'&$orderby=Name&$select=Oid,Name&$format=json`
    );

    dispatch({ type: FETCH_SORT_OPTIONS, payload: response.data.d });
  };
};

export const fetchStrainTypes = () => {
  return async dispatch => {
    const response = await klerData.get(
      `/StrainType?$filter=Oid ne 1&$orderby=Oid&$select=Oid,Name,ColorCode&$expand=ColorCode&$format=json`
    );

    dispatch({ type: FETCH_STRAIN_TYPES, payload: response.data.d });
  };
};

export const fetchSubscription = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/Subscription?$filter=SubscriptionId eq '${SubscriptionId}'&$select=Oid,SubscriptionId,FirstName,LastName,Business,Email,Phone,Promo,ZohoId&$format=json`
    );

    dispatch({ type: FETCH_SUBSCRIPTION, payload: response.data.d });
  };
};

export const fetchTerpeneProfiles = SubscriptionId => {
  return async dispatch => {
    const response = await klerData.get(
      `/TerpeneProfile?$filter=Oid ne 1 and SubscriptionId eq '${SubscriptionId}'&$orderby=Name&$select=Oid,Name,ColorCode&$expand=ColorCode&$format=json`
    );

    dispatch({ type: FETCH_TERPENE_PROFILES, payload: response.data.d });
  };
};

export const fetchThemes = () => {
  return async dispatch => {
    const response = await klerData.get(
      `/Theme?$filter=Oid ne 1&$orderby=Name&$select=Oid,Name,Type&$format=json`
    );

    dispatch({ type: FETCH_THEMES, payload: response.data.d });
  };
};

export const fetchUserLocations = Email => {
  return async dispatch => {
    const response = await klerData.get(
      `/UserAccess?$filter=Email eq '${Email}' and SubscriptionId ne null&$orderby=SubscriptionId/Business&$select=Oid,Email,Admin,SubscriptionId&$expand=SubscriptionId&$format=json`
    );

    dispatch({ type: FETCH_USER_LOCATIONS, payload: response.data.d });
  };
};

export const fetchZohoCustomers = () => {
  return async dispatch => {
    const response = await zohoData.get(`/customers`);

    dispatch({ type: FETCH_ZOHO_CUSTOMERS, payload: response.data });
  };
};

export * from "./sessionActions";

export const CONSTANTS = {
  SET_ACTIVE_LOCATION: "SET_ACTIVE_LOCATION"
};
